module.exports = __webpack_public_path__ + "img/gamesdk4.64aea36.png";